import { STORIES_PATH } from "./App";

export const getStorySlug = (storyHeader) =>
  `${STORIES_PATH}/${storyHeader.replace(/\s+/g, "-").toLowerCase()}`;
